import { Component, ViewChild, ElementRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { IAppState } from '../app.state';
import { IVisualState } from '../visual/visual.reducer';
import { selectCurrentShare } from '../share/models';
import { Subscription } from 'rxjs';

const embedFullSizeAttributes = `style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"`;
const embedAttributes = `frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen`;

const embedWidth = 640;
const embedHeight = 400;
const defaultRatio = {width: 16, height: 10};

@Component({
  selector: 'nns-embed-popup',
  template: `
    <form class="form">
      <div class="nns-control nns-control__row">
        <div class="nns-control_label">Fixed size</div>
        <div class="nns-control_switch"
          [ngClass]="{'nns-control_switch__active': isFixedSizeActive}"
          (click)="onToogleIsFixedSize()"></div>
      </div>
      <div class="nns-control nns-control__row" *ngIf="isBussines">
        <div class="nns-control_label">Show branding in embed</div>
        <div class="nns-control_switch"
          [ngClass]="{'nns-control_switch__active': isShowTopBar}"
          (click)="onToggleShowTopBar()"></div>
      </div>
      <div class="nns-control_group nns-control_group__row" *ngIf="isFixedSizeActive">
        <div class="nns-control nns-control__row">
          <div class="nns-control_label">Width</div>
          <input
            #widthInput
            type="number"
            class="nns-control_input nns-control_input__small"
            (change)="onWidthKeyUp(widthInput)"
            (keyup)="onWidthKeyUp(widthInput)"
            [value]="embedWidth"
          />
        </div>
        <div class="nns-control nns-control__row">
          <div class="nns-control_label">Height</div>
          <input
            #heightInput
            type="number"
            class="nns-control_input nns-control_input__small"
            (change)="onHeightKeyUp(heightInput)"
            (keyup)="onHeightKeyUp(heightInput)"
            [value]="embedHeight"
          >
        </div>
      </div>
      <div class="nns-control">
        <div class="nns-control_label nns-control_label__gray">Embed code</div>
        <div class="nns-control nns-control__row">
          <input
            #embedInput
            class="nns-control_input"
            [readonly]="true"
            [value]="embedCode"
            (click)="copyCode()"
          />
          <a class="nns-link" (click)="copyCode()"  *ngIf="!isCopied">Copy code</a>
          <a class="nns-link nns-link__no-click" (click)="copyCode()" *ngIf="isCopied">Copied!</a>
        </div>
      </div>
      <div class="nns-control nns-control__row" *ngIf="!isVideo">
        <div class="nns-control_label">Enable print</div>
        <div class="nns-control_switch"
          [ngClass]="{'nns-control_switch__active': isPrintActive}"
          (click)="onToggleIsPrintActive()"></div>
      </div>
    </form>
  `,
  styles: [`
    .form{
      display: flex;
      flex-direction: column;
    }
    .nns-control_group{
      display: flex;
      flex-direction: column;
    }
    .nns-control_group__row{
      flex-direction: row;
    }
    .nns-control:not(:last-child){
      margin-bottom: 15px;
    }
    .nns-control:not(.nns-control__row) .nns-control_label{
      margin-bottom: 13px;
    }
    .nns-control__row{
      display: flex;
      align-items: center;
    }
    .nns-control_group__row .nns-control:not(:first-child){
      margin-left: 10px;
    }
    .nns-control_group .nns-control {
      margin-bottom: 0;
    }
    .nns-control_group:not(:last-child){
      margin-bottom: 15px;
    }
    .nns-control_label{
      font-size: 13px;
      line-height: 16px;
      margin-right: 10px;
    }
    .nns-control_label__gray{
      color: #5C6061;
    }
    .nns-control_input{
      height: 44px;
      width: 100%;
      border: 1px solid rgba(0, 0, 0, 0.12);
      font-weight: bold;
      padding: 0 8px;
      box-sizing: border-box;
      border-radius: 4px;
    }
    .nns-control_input[disabled]{
      background-color: #fff;
    }
    .nns-control_switch{
      width: 34px;
      height: 14px;
      background-color: #AEB7B8;
      border-radius: 16px;
      position: relative;
      transition: 0.2s;
      cursor: pointer;
    }
    .nns-control_switch::before{
      content: '';
      width: 20px;
      height: 20px;
      position: absolute;
      background: #F5F5F5;
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.237602), 0px 0px 1px rgba(0, 0, 0, 0.12);
      top: -3px;
      left: 0;
      border-radius: 50%;
      transition: 0.2s;
    }
    .nns-control_switch__active{
      background-color: rgb(0,161,183,.5);
    }
    .nns-control_switch__active::before{
      left: calc(100% - 20px);
      background-color: #00A1B7;
    }
    .nns-control_input__small{
      height: 30px;
      width: 70px;
      font-weight: normal;
      text-align: center;
    }
    .nns-control_submit-check{
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background-color: #00A1B7;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 2px;
      box-sizing: border-box;
    }
    .nns-link{
      white-space: nowrap;
      margin-left: 14px;
      font-weight: bold;
      font-size: 13px;
    }
    .nns-link__no-click{
      cursor: default;
    }
  `, `
    :host-context(.nns-theme-night) .nns-control_label__gray {
      color: #fff;
    }
    :host-context(.nns-theme-night) .nns-control_input {
      background-color: rgba(255, 255, 255, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.16);
      color: rgba(255, 255, 255, 0.87);
    }
  `]
})
export class EmbedPopupComponent {
  @ViewChild('embedInput') embedInputElement: ElementRef;
  isFixedSizeActive: boolean;
  isPrintActive: boolean;
  isShowTopBar: boolean = true;
  embedCode: string;
  embedWidth = embedWidth;
  embedHeight = embedHeight;
  isCopied = false;
  isVideo = false;
  isBussines;
  subscription = new Subscription;
  aspectRatio = defaultRatio;
  videoSize;
  isLoaded: boolean;

  constructor(
    public _store: Store<IAppState>,
  ) {
    const visual$ = this._store.select<IVisualState>('visual');
    const share$ = this._store.pipe(select(selectCurrentShare));
    this.generateEmbedCode();
    this.subscription.add(visual$.subscribe((visual) => {
      const isVideo = visual.isVideo;
      if(isVideo && isVideo != this.isVideo) {
        this.isVideo = isVideo;
        const videoSize = this.getVideoSize();
        this.videoSize = videoSize;
        this.embedWidth = videoSize.width;
        this.embedHeight = videoSize.height;
        this.isPrintActive = false;
        this.setEmbedSizeByHeight(this.embedHeight);
        this.generateEmbedCode();
      }
      this.isLoaded = true;
    }))

    this.subscription.add(
      share$.subscribe((share) => {
        this.isBussines = share.instance && share.instance.org && share.instance.org.orgType === 'business';
      })
    )

    this.isPrintActive = localStorage.getItem('nns-print-active') === 'true';
  }

  onToogleIsFixedSize() {
    this.isFixedSizeActive = !this.isFixedSizeActive;
    if(this.isVideo) {
      const height = this.videoSize.height;
      this.setEmbedSizeByHeight(height);
    }
    this.generateEmbedCode();
  }

  onToggleShowTopBar() {
    this.isShowTopBar = !this.isShowTopBar;
    this.generateEmbedCode();
  }

  onToggleIsPrintActive() {
    this.isPrintActive = !this.isPrintActive;
    this.generateEmbedCode();
    localStorage.setItem('nns-print-active', this.isPrintActive.toString());
  }

  onWidthKeyUp(widthInput) {
    const width = Number.parseInt(widthInput.value);
    this.setEmbedSizeByWidth(width);
    this.generateEmbedCode();
  }

  onHeightKeyUp(heightInput) {
    const height = Number.parseInt(heightInput.value);
    this.setEmbedSizeByHeight(height);
    this.generateEmbedCode();
  }

  setEmbedSizeByWidth(width) {
    const ratio = this.getAspectRatio();
    this.embedWidth = width;
    this.embedHeight = Math.floor((width / ratio.width) * ratio.height);
  }

  setEmbedSizeByHeight(height) {
    const ratio = this.getAspectRatio();
    this.embedHeight = height;
    this.embedWidth = Math.floor((height) / ratio.height * ratio.width);
  }

  generateEmbedCode() {
    if(this.isLoaded) {
      const pageUrl = this.getEmbedUrl();
      if(this.isFixedSizeActive) {
        this.embedCode = this.getFixedSizeEmbedCode(pageUrl);
      } else {
        this.embedCode = this.getFullSizeEmbedCode(pageUrl);
      }
      this.isCopied = false;
    } else {
      setTimeout(() => {
        this.generateEmbedCode();
      }, 10)
    }
  }

  getEmbedUrl() {
    const {origin, pathname, hash } = window.location;
    const isPrintActive = this.isVideo ? false : this.isPrintActive;
    return `${origin}${pathname}/?embed=true${!this.isShowTopBar ? '&hide-header=true': ''}${isPrintActive ? '&print-enabled=true' : ''}${hash}`;
  }

  getFullSizeEmbedCode(pageUrl) {
    const padding = this.getEmbedPaddingTop();
    return `<div style="position: relative; padding-bottom: ${padding}; height: 0;">`
    + `<iframe src="${pageUrl}" ${embedAttributes}  ${embedFullSizeAttributes}></iframe></div>`
  }

  getFixedSizeEmbedCode(pageUrl) {
    let height = this.embedHeight;
    if(this.isVideo) height += 42;
    return `<iframe src="${pageUrl}" ${embedAttributes}`
    + ` width="${this.embedWidth}" height="${height}"></iframe>`;
  }

  getAspectRatio() {
    if(this.isVideo) {
      const videoHeight = this.videoSize.height;
      const videoWidth = this.videoSize.width;
      if(this.isFixedSizeActive) {
        return {width: videoWidth / 10, height: videoHeight / 10};
      } else {
        return {width: videoWidth / 10, height: videoHeight / 10};
      }
    } else {
      return defaultRatio;
    }
  }

  getEmbedPaddingTop() {
    const ratio = this.getAspectRatio();
    const percenst = (ratio.height * 100) / ratio.width;
    return `calc(${percenst}% + 42px)`;
  }

  getVideoSize() {
    const videoPlayerElements = document.getElementsByClassName('video-player');
    if(videoPlayerElements && videoPlayerElements.length) {
      const videoPlayerElement = videoPlayerElements[0];
      const videoElement = videoPlayerElement.getElementsByTagName('video')[0];
      return {width: videoElement.offsetWidth, height: videoElement.offsetHeight};
    } else {
      return {width: 1680, height: 1050};
    }
  }

  copyCode() {
    this.embedInputElement.nativeElement.select();
    document.execCommand('copy');
    this.isCopied = true;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
